import { useQueryClient } from "@tanstack/react-query"
import { Navigate, Outlet, useLocation } from "react-router"

import { useAccessToken, useSessionStore } from "../../../stores"
import { useProfile } from "../../../hooks"
import { Profile } from "../../../types"

export const BirddogProtectedRoute = () => {
  const location = useLocation()
  const accessToken = useAccessToken()
  const queryClient = useQueryClient()
  useProfile<Profile, Error>(queryClient, {
    enabled: !!accessToken,
  })
  const authData = useSessionStore((state) => state.authData)
  const isLoggedIn = !!accessToken

  // Check if user is logged in
  if (!isLoggedIn) {
    return <Navigate replace to="/birddog/login" state={{ from: location }} />
  }

  // Check if user has BirdDog role (from JWT token data stored in session)
  if (authData && !authData.birddog_role) {
    return (
      <Navigate
        replace
        to="/birddog/login"
        state={{
          from: location,
          error:
            "This login is for BirdDog users only. Please use the main NCX login.",
        }}
      />
    )
  }

  return <Outlet />
}
